import { parseJwt } from 'gso-jwt';
import { read } from 'gso-session';
import * as Sentry from '@sentry/browser';
import { deleteToken as deleteTokenPetrus } from './petrus-proxy';
import { deleteToken as deleteTokenAuth } from './auth-proxy';
async function logout(resolve) {
    const jwt = parseJwt(read('token'));
    const deleteToken = jwt ? deleteTokenAuth : deleteTokenPetrus;
    try {
        await deleteToken();
    }
    catch (error) {
        Sentry.captureException(error);
    }
    finally {
        sessionStorage.clear();
        const portal = jwt ? 'portal' : 'portalbe';
        const logoutUrl = `../${portal}/#logout`;
        location.href = resolve ? resolve(logoutUrl) : logoutUrl;
    }
}
export default logout;
//# sourceMappingURL=logout.js.map